"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertKeskoAPIProductToPrefill = void 0;
const products_1 = require("../types/products");
/** format such as '1.39' -> 1390 */
const convertKPriceToCents = (price) => parseFloat(price) * 100;
const convertKeskoAPIProductToPrefill = ({ ean, brand, localizedName, pictureUrls, contentSize, contentUnit, description, prices, origin }) => {
    var _a, _b, _c, _d, _e;
    const discount = (prices === null || prices === void 0 ? void 0 : prices.isDiscounted) ? true : false;
    const productPrices = (_a = prices === null || prices === void 0 ? void 0 : prices.preprocessedPricing) === null || _a === void 0 ? void 0 : _a.products;
    let price = 0; // price in cents
    let discountPrice = 0; // price in cents
    if (productPrices && productPrices[ean]) {
        const preprocessedPricing = productPrices[ean];
        if ((_b = preprocessedPricing.price) === null || _b === void 0 ? void 0 : _b.value) {
            price = convertKPriceToCents(preprocessedPricing.price.value);
        }
        // handle deposists
        if (preprocessedPricing.components) {
            for (const component of preprocessedPricing.components) {
                if (((_c = component.price) === null || _c === void 0 ? void 0 : _c.value) && component.multiplier) {
                    price += convertKPriceToCents(component.price.value) * component.multiplier;
                }
            }
        }
        // handle product promotions
        if (preprocessedPricing.productPromotions) {
            for (const promotion of preprocessedPricing.productPromotions) {
                if ((_e = (_d = promotion.rule) === null || _d === void 0 ? void 0 : _d.price) === null || _e === void 0 ? void 0 : _e.value) {
                    discountPrice += convertKPriceToCents(promotion.rule.price.value);
                }
            }
        }
    }
    // TODO add deposit also to basket promotions
    // TODO calculate prices when batch size
    const prefillProductData = {
        productId: ean,
        name: localizedName === null || localizedName === void 0 ? void 0 : localizedName.finnish,
        brand,
        imageUrl: pictureUrls ? pictureUrls[0] : undefined,
        unit: prices === null || prices === void 0 ? void 0 : prices.pricingUnit,
        packageSize: contentSize,
        packageUnit: contentUnit,
        description: description === null || description === void 0 ? void 0 : description.finnish,
        discount: (prices === null || prices === void 0 ? void 0 : prices.isDiscounted) ? true : false,
        price: price === 0 ? undefined : price,
        country: origin === null || origin === void 0 ? void 0 : origin.countryOfOriginFi
    };
    if (discount && discountPrice !== 0) {
        prefillProductData.discountPrice = discountPrice;
        prefillProductData.tags = [products_1.ProductTags.discount];
    }
    return prefillProductData;
};
exports.convertKeskoAPIProductToPrefill = convertKeskoAPIProductToPrefill;
//# sourceMappingURL=kRuoka.js.map